import { PiDotsNine } from "react-icons/pi";

import { ZoneType } from "@/codegen/openapi2";
import { EditableRadio } from "@/components/2/editable-radio";
import { useGetRegionsGeographiesRegionsGet } from "@/services/2/react-query/hooks";

type RegionSelectorCellProps = {
  zone: ZoneType;
  onUpdate?: (zone: ZoneType, field: string, value: string) => void;
};

export const RegionSelectorCell = ({ zone, onUpdate }: RegionSelectorCellProps) => {
  const { data: regions } = useGetRegionsGeographiesRegionsGet({}, ["regions"], {
    placeholderData: [],
    staleTime: 60 * 60 * 1000, // 1 hour
  });

  const handleChange = (regionUuid: string | null) => {
    if (regionUuid && onUpdate) {
      onUpdate(zone, "region_uuid", regionUuid);
    }
  };

  if (!regions) {
    return <p>Chargement...</p>;
  }

  const sortedRegions = regions.sort((a, b) => a.name.localeCompare(b.name));

  // If read-only, just display the region name
  if (!onUpdate) {
    const currentRegion = sortedRegions.find(region => region.uuid === zone.region_uuid);
    return (
      <div style={{ minHeight: "24px", padding: "2px", opacity: 0.7 }}>
        {currentRegion?.name || "No region"}
      </div>
    );
  }

  return (
    <EditableRadio
      name="regions"
      value={zone.region_uuid}
      onChangeValue={handleChange}
      options={sortedRegions.map(region => ({
        value: region.uuid,
        label: region.name,
      }))}
      allowUnselect={false}
      toggleIcon={<PiDotsNine />}
    />
  );
};
